import styled from 'styled-components'

const BlackWrapper = ({children}) => {
    return (
        <Wrapper>
            {children}
        </Wrapper>
    )
}
export default BlackWrapper

const Wrapper = styled.div`
    
    background-color: #333;
    background-size: cover;
    background-attachment: fixed;
    background-repeat: no-repeat;
    color: #eee;
`